// ----------------------------------------------------------------------------
// Template: Account
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_account.scss';

// Variables
const SIGN_OUT_BUTTON = '.button__sign-out';

// Functions
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}

const signOutButtons = document.querySelectorAll(SIGN_OUT_BUTTON);
signOutButtons.forEach((button) => {
    button.addEventListener('click', function(e) {
        e.preventDefault();

        if (getCookie('cart') != null) {
            eraseCookie('cart');
        }

        const targetUrl = e.target.getAttribute('href');
        window.location = targetUrl;
    })
})

